import React, { useState, useEffect } from "react";
import _ from "lodash";
import data from "../../data/professioni.json";

import { TextField } from "@mui/material";
import SlideMainTitle from "../slides-components/Title";
import SlideWrapper from "../slides-components/SlideWrapper";

const SlideProfessione = ({ urlParameters, navigate, queryString }) => {
  // ------------------------------------
  // URL
  const [professioneId, setProfessioneId] = useState(null);

  useEffect(() => {
    if (professioneId !== null) {
      let id = _.findKey(data.professioni, function (o) {
        return o.id === professioneId;
      });

      let cassa = 0;
      let contributi = 0; // default - scelta libera si/no

      if (data.professioni[id].tipologia.includes("Cassa Privatizzata")) {
        cassa = 1;
        if (urlParameters.fullTime === "1") {
          // full time E cassa privatizzata
          contributi = 2;
        } else {
          // no full time ma cassa privatizzata
          contributi = 1;
        }
      } else {
        // full time semplice quindi no contributi
        if (urlParameters.fullTime === "1") {
          // full time E cassa privatizzata
          contributi = 3;
        }
      }

      let ibrido = 0;
      let gestionePrevidenziale = 3;

      if (data.professioni[id].tipologia.length === 1) {
        ibrido = 0;
        switch (data.professioni[id].tipologia.join("")) {
          case "Artigiano":
            gestionePrevidenziale = 0;
            break;
          case "Commercio":
            gestionePrevidenziale = 2;
            break;
          case "Professionista":
            gestionePrevidenziale = 3;
            break;
          case "Cassa Privatizzata":
            cassa = 1;
            gestionePrevidenziale = 4;
            break;
          default:
            break;
        }
      } else {
        // ibrido
        ibrido = 1;
        switch (data.professioni[id].tipologia.join(", ")) {
          case "Artigiano, Professionista":
            gestionePrevidenziale = 5;
            break;
          case "Commercio, Professionista":
            gestionePrevidenziale = 6;
            break;
          default:
            break;
        }
      }

      const newQueries = {
        ...urlParameters,
        currentStep: parseInt(urlParameters.currentStep) + 1,
        professione: professioneId,
        cassa: cassa,
        ibrido: ibrido,
        contributi: contributi,
        gestionePrevidenziale: gestionePrevidenziale,
        eccezioneINPS: data.professioni[id].eccezione_inps === "1" ? 1 : 0,
        eccezioneENPALS: data.professioni[id].eccezione_enpals === "1" ? 1 : 0,
      };
      navigate("/calcolatore/?" + queryString.stringify(newQueries));
    }
  }, [professioneId, urlParameters, navigate, queryString]);

  // ------------------------------------
  // Text search
  const [q, setQ] = useState("");

  const normalize = (str) => _.toLower(_.deburr(str));

  function search() {
    let indexes = [];
    const search = normalize(q);
    data.professioni.forEach((professione, index) => {
      if (_.some(professione, (v) => normalize(v).includes(search)) === true) {
        indexes.push(index);
      }
    });

    if (indexes.length > 0) {
      return { indexes: indexes, hasResults: true };
    } else {
      return {
        indexes: Array.from(Array(data.professioni.length - 1).keys()),
        hasResults: false,
      };
    }
  }
  // ------------------------------------
  return (
    <SlideWrapper preventCenterAlignment={true}>
      <div className="dark:bg-gray-700 w-full flex flex-col  justify-start pb-4 px-4 sticky top-0 ">
        <div className="text-center mb-8 pt-4">
          <SlideMainTitle text={"Che professione vorresti svolgere?"} />

          <p className="md:text-2xl">
            {" "}
            Cerca per professione, codice ATECO o redditività{" "}
          </p>
        </div>

        <TextField
          fullWidth
          id="searchField"
          name="searchField"
          label="Cerca"
          onChange={(e) => setQ(e.target.value)}
          error={!search().hasResults}
          helperText={!search().hasResults && "Nessun risultato trovato"}
          InputLabelProps={{
            style: { color: "orange" },
          }}
          sx={{
            ".css-x2l1vy-MuiInputBase-root-MuiOutlinedInput-root": {
              color: "orange",
            },
          }}
          InputProps={{
            sx: {
              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                border: "1px solid orange!important",
                color: "orange",
              },
              "&:focus": {
                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid orange",
                },
              },

              "&:hover": {
                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid orange",
                },
              },
            },
            className: "",
            classes: {
              root: " dark:bg-gray-800 dark:text-white",
              focused: "",
            },
          }}
        />
        {!search().hasResults && (
          <div className="ml-[14px]">
            Non riesci a trovare la tua professione?
            <a
              href="https://fidocommercialista.it/registrati/"
              target={"_blank"}
              rel="noreferrer"
              className="text-orange-400"
            >
              {" "}
              Richiedi una consulenza gratuita
            </a>
          </div>
        )}
      </div>
      <div className="w-full overflow-scroll px-4 md:px-10 lg:px-20 pt-8 pb-8">
        {search().indexes.map((found_index, index) => {
          let professione = data.professioni[found_index];
          return (
            <button
              key={`professione-${index}`}
              className={`${
                professioneId === index && "selected"
              } border-b w-full flex flex-row gap-x-2 md:gap-x-8 items-center justify-between dark:hover:bg-orange-300 dark:hover:text-black hover:bg-orange-300 duration-75 p-2`}
              onClick={() => {
                setProfessioneId(professione.id);
              }}
            >
              <div className="text-left leading-[1]">
                <p className="font-bold mb-2">{professione.nome}</p>
                <p>{professione.descrizione}</p>
              </div>
              <div className="flex flex-col md:flex-row gap-x-10 ">
                <p>{professione.codice_ateco}</p>
                <p>{`${professione.redditivita}%`}</p>
              </div>
            </button>
          );
        })}
      </div>
    </SlideWrapper>
  );
};

export default SlideProfessione;
